// Angular
import { Component, Input } from '@angular/core';
import { IOsi } from 'libraries/service/resources/booking/interfaces/IGetBookings';

@Component({
    selector: 'osi',
    template: `
        <div class="container">
            <div class="col-left">
                {{ osi.vendor.code }}
            </div>

            <div class="col-right">
                {{ osi.text }}
            </div>
        </div>
    `,
    styleUrls: ['../shared/remark.scss']
})
export class OsiComponent {
    @Input()
    public osi: IOsi;

    public dateFormat:  { momentShort: string } = JSON.parse(sessionStorage.getItem('dateFormat'));
}